import React, { useState } from 'react';

import Modal from "react-modal";

import './ModalProgramCreate.scss';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        width: '670px',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        overflow: 'visible',
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};

Modal.setAppElement('#root');

const programTemplates = [
    {
        id: 0,
        name: "Blank program",
        vitals: []
    },
    {
        id: 1,
        name: "High Risk Patients",
        vitals: [
            {
                label: 'Weight',
                value: 'W'
            },
            {
                label: 'Respiratory Rate',
                value: 'RR'
            },
            {
                label: 'Heart Rate',
                value: 'HR'
            },
            {
                label: 'Position',
                value: 'Position'
            },
            {
                label: 'Blood pressure',
                value: 'BP'
            },
            {
                label: 'SpO2',
                value: 'SpO2'
            },
            {
                label: 'Temperature',
                value: 'Temp'
            }
        ]
    },
    {
        id: 2,
        name: "Safe @ Home",
        duration: 15, // days
        vitals: [
            {
                label: 'SPO2',
                value: 'SPO2',
                order: 1
            },
            {
                label: 'Respiratory Rate',
                value: 'RR',
                order: 2
            },
            {
                label: 'Temperature',
                value: 'Temp',
                order: 3
            },
            {
                label: 'Heart Rate',
                value: 'HR',
                order: 4
            }
        ]
    },
];

function ProgramTemplate({ template, selectedTemplate, onClick}) {
    const maxDisplayVital = 4;
    const _onClick = () => {
        onClick(template);
    }

    const vitalAcronym = (value) => {
        if (value === 'SPO2') { return 'O2' }
        if (value === 'Temp') { return 'T' }
        if (value === 'Position') { return 'P' }
        return value;
    }

    const selected = selectedTemplate? selectedTemplate.name === template.name : false;

    return (
        <div className={`cardProgram ${selected ? 'selected' : ''}`} onClick={_onClick}>
            <div className="cardInfo">
                <span className="name">{ template.name }</span>
                {
                    template.id === 0? '' :
                        <span className="duration">
                            <span>Duration:</span>
                            <span>
                                {
                                   template.duration? template.duration + ' days' : 'Not defined'
                                }
                            </span>
                        </span>
                }
            </div>
            <div className="vitals" >
                {
                    template.vitals.map((vital, index) => (
                        index < maxDisplayVital?
                            <span key={index} className={`_vital _${vital.value}`} >{ vitalAcronym(vital.value) }</span> : ''
                    ))
                }
                {
                    template.vitals.length > maxDisplayVital? <span className="_vital _more">+{template.vitals.length-maxDisplayVital}</span> : ''
                }
            </div>
        </div>
    )
}

function ModalProgramCreate({ openModal, closeModal }) {
    const [selectedTemplate, setSelectedTemplate] = useState(programTemplates[0]);

    const closeModalEmpty = () => {
        closeModal(false, selectedTemplate);
    }

    const closeModalSuccess = () => {
        closeModal(true, selectedTemplate);
    }

    const onTemplateSelected = (template) => {
        setSelectedTemplate(template);
    }

    return (
        <Modal
            isOpen={openModal}
            onRequestClose={closeModalEmpty}
            style={customStyles}
            contentLabel="Patient kit assignment" >
                <div id="ProgramCreate">
                    <div className="modalHeader">
                        <div className="_title">
                            New program templates
                        </div>
                        <div className="iconClose">
                            <span className="material-icons" onClick={closeModalEmpty}>
                                close
                            </span>
                        </div>
                    </div>
                    <div className="modalBody" >
                        {
                            programTemplates.map((template, index) => (
                                <ProgramTemplate key={index} template={template} selectedTemplate={selectedTemplate} onClick={onTemplateSelected} />
                            ))
                        }
                    </div>
                    <div className="modalFooter">
                        <button className="button link" onClick={closeModalEmpty}>Cancel</button>
                        <button className="button primary" onClick={closeModalSuccess}>Choose</button>
                    </div>
                </div>
        </Modal>
    )
}

export { programTemplates, ModalProgramCreate };